
/**
 * @param {string} searchBoxId
 * @param {string} searchBoxPlaceholder
 * @param {string} searchBoxLabel
 
 * @param {string} searchContent
 * @param {function} handleChange
 * @param {function} executeSearch
 * @param {function} clearSearch
 */
function SearchBox(props) {
    let clearIconHiddenClassName = "hidden";
    if (props.searchContent !== "") {
        clearIconHiddenClassName = "";
    }

    return (
      <div className="book-meeting--search-input">
        <fieldset className="book-meeting__search-box">
          <label htmlFor={props.searchBoxId} className="form-label">
            {props.searchBoxLabel}
          </label>
          <div className="book-meeting__field-wrapper">
            <input
              className="book-meeting__search-input"
              id={props.searchBoxId}
              type="search"
              placeholder={props.searchBoxPlaceholder}
              aria-label="Søk etter rådgiver"
              aria-describedby="searchbutton"
              value={props.searchContent}
              onChange={(e) => {
                const value = e.target.value;
                props.handleChange(value);
                if (value === "" && props.clearSearch) {
                  props.clearSearch();
                }
              }}
              onKeyUp={(e) => {
                // trigger if they press enter within the input field
                if (e.key === "Enter" || e.keyCode === 13) {
                  props.executeSearch();
                }
              }}
            />
            <button
              className="button button--primary button--small md:flex gap-3"
              type="button"
              onClick={() => {
                props.executeSearch();
              }}
              aria-label="Søk etter rådgiver"
            >
              <span className=" text-lg">Søk</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="23"
                viewBox="0 0 24 23"
                fill="none"
              >
                <path
                  d="M10.4863 18.5999C15.3214 18.5999 19.2411 14.6802 19.2411 9.84503C19.2411 5.00987 15.3214 1.09021 10.4863 1.09021C5.65111 1.09021 1.73145 5.00987 1.73145 9.84503C1.73145 14.6802 5.65111 18.5999 10.4863 18.5999Z"
                  stroke="currentColor"
                  strokeWidth="1.715"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M22.4248 21.7833L16.8535 16.212"
                  stroke="currentColor"
                  strokeWidth="1.715"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
          </div>
        </fieldset>
        <ul className="row searchResult list-unstyled">{props.children}</ul>
      </div>
    );
}
export default SearchBox;